<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CN" id="_idParaDest-3"><span class="CharOverride-3"> <img alt="" class="_idGenObjectAttribute-2" src="image/EuphoriaTitle1.png"/></span></p>
<p class="BT1stPara ParaOverride-3"><span class="CharOverride-4">A NOVEL</span></p>
<p class="BT1stPara ParaOverride-4"><span class="CharOverride-5">LILY KING</span></p>
<p class="BT1stPara ParaOverride-5"><img alt="" class="_idGenObjectAttribute-3" src="image/V-1.png"/></p>
<p class="BT1stPara ParaOverride-2">Grove Press</p>
<p class="BT1stPara ParaOverride-2"><span class="CharOverride-2">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook42762.vue?d5b1ce9c